import { createRouter, createWebHistory } from "vue-router";
import DashboardView from "@/views/Dashboard/DashboardView.vue";
import LoginView from "@/views/Auth/LoginView.vue";
import CoursesView from "@/views/Dashboard/Courses/CoursesView.vue";
import KpiView from "@/views/Dashboard/Courses/KpiView.vue";
import CourseView from "@/components/Dashboard/Courses/Course/core/CourseView.vue";
import NotFoundView from "@/views/NotFoundView.vue";
import UtilitiesView from "@/views/Dashboard/Utilities/UtilitiesView.vue";
import ConfigView from "@/views/Dashboard/Utilities/ConfigView.vue";
import SectionsView from "@/views/Dashboard/Utilities/SectionsView.vue";
import HolesView from "@/views/Dashboard/Utilities/HolesView.vue";
import DrivingRangePinsView from "@/views/Dashboard/Utilities/DrivingRangePinsView.vue";
import CentralUsersView from "@/views/Dashboard/Users/CentralUsersView.vue";
import CourseUsersView from "@/views/Dashboard/Users/CourseUsersView.vue";
import MapFlagsView from "@/views/Dashboard/Utilities/MapFlagsView.vue";
import TeesheetIntegrationView from "@/views/Dashboard/Utilities/TeesheetIntegrationView.vue";
import TotalDevicesView from "@/views/Dashboard/Devices/TotalDevicesView.vue";
import BulkDevicesUploadView from "@/views/Dashboard/Devices/BulkDevicesUploadView.vue";
import useCourseOutlinesView from "@/views/Dashboard/Utilities/CourseOutlinesView.vue";
import ArchivedDevicesView from "@/views/Dashboard/Devices/ArchivedDevicesView.vue";
import HistoricalLogsView from "@/views/Dashboard/Devices/HistoricalLogsView.vue";
import HardwareReportView from "@/views/Dashboard/Devices/HardwareReportView.vue";
import DefaultTeeTimesView from "@/views/Dashboard/Utilities/DefaultTeeTimesView.vue";
import AppActionLogsView from "@/views/Dashboard/Devices/AppActionLogsView.vue";
import WindTagDevicesView from "@/views/Dashboard/Devices/WindTagDevicesView.vue";
import RangeSectionsView from "@/views/Dashboard/Utilities/RangeSectionsView.vue";
import DrivingRangeQRCodeView from "@/views/Dashboard/Utilities/DrivingRangeQRCodeView.vue";
import GolfWeatherIntegrationView from "@/views/Dashboard/Utilities/GolfWeatherIntegrationView.vue";

const routes = [
  {
    path: "/",
    name: "default",
    redirect: () => {
      const token = localStorage.getItem("user_token");
      return token ? { name: "courses" } : { name: "login" };
    },
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: DashboardView,
    children: [
      {
        path: "courses",
        name: "courses",
        component: CoursesView,
        meta: {
          title: "all-courses",
          menu: "courses",
        },
      },
      {
        path: "courses/kpis",
        name: "kpis",
        component: KpiView,
        meta: {
          title: "courses-kpi",
          menu: "courses",
        },
      },
      {
        path: "courses/course/:id",
        name: "course",
        component: CourseView,
        meta: {
          title: "course",
          menu: "courses",
        },
      },

      {
        path: "devices",
        name: "devices",
        component: TotalDevicesView,
        meta: {
          title: "total-devices",
          menu: "devices",
        },
      },

      {
        path: "devices/archived-devices",
        name: "archived-devices",
        component: ArchivedDevicesView,
        meta: {
          title: "archived-devices",
          menu: "devices",
        },
      },

      {
        path: "devices/app-action-logs",
        name: "app-action-logs",
        component: AppActionLogsView,
        meta: {
          title: "app-action-logs",
          menu: "app-action-logs",
        },
      },

      {
        path: "devices/hardware-report",
        name: "hardware-report",
        component: HardwareReportView,
        meta: {
          title: "hardware-report",
          menu: "hardware-report",
        },
      },

      {
        path: "devices/historical-logs",
        name: "historical-logs",
        component: HistoricalLogsView,
        meta: {
          title: "historical-logs",
          menu: "Historical Logs",
        },
      },

      {
        path: "devices/bulk-devices-upload",
        name: "bulk-devices-upload",
        component: BulkDevicesUploadView,
        meta: {
          title: "bulk-devices-upload",
          menu: "devices",
        },
      },

      {
        path: "utilities/dashboard",
        name: "utilities",
        component: UtilitiesView,
        meta: {
          title: "utility",
        },
      },
      {
        path: "utilities/sections",
        name: "sections",
        component: SectionsView,
      },
      {
        path: "utilities/holes",
        name: "holes",
        component: HolesView,
      },
      {
        path: "utilities/config",
        name: "config",
        component: ConfigView,
      },

      {
        path: "utilities/map-flags",
        name: "map-flags",
        component: MapFlagsView,
      },

      {
        path: "utilities/course-outlines",
        name: "course-outlines",
        component: useCourseOutlinesView,
      },

      {
        path: "utilities/teesheet-integration",
        name: "teesheet-integration",
        component: TeesheetIntegrationView,
      },
      {
        path: "utilities/driving-range-sections",
        name: "driving-range-sections",
        component: RangeSectionsView,
      },

      {
        path: "utilities/default-tee-times",
        name: "default-tee-times",
        component: DefaultTeeTimesView,
      },

      {
        path: "utilities/driving-range-qr-code",
        name: "driving-range-qr-code",
        component: DrivingRangeQRCodeView,
      },

      {
        path: "utilities/driving-range-pins",
        name: "driving-range-pins",
        component: DrivingRangePinsView,
      },

      {
        path: "users/central-users",
        name: "central-users",
        component: CentralUsersView,
        meta: {
          title: "central-users",
          menu: "users",
        },
      },
      {
        path: "users/course-users",
        name: "course-users",
        component: CourseUsersView,
        meta: {
          title: "course-users",
          menu: "users",
        },
      },
      {
        path: "devices/windtag-devices",
        name: "windtag-devices",
        component: WindTagDevicesView,
        meta: {
          title: "windtag-devices",
          menu: "devices",
        },
      },
      {
        path: "utilities/golf-weather-integration",
        name: "golf-weather-integration",
        component: GolfWeatherIntegrationView,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  // TODO: redirect to dashboard if no route matched
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: NotFoundView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("user_token");

  // prevet access to any page if not logged in
  if (!token && to.name !== "login") {
    next({ name: "login" }); // redirect to login
    return;
  }
  next();
});

export default router;
